module.exports = __webpack_public_path__ + "img/bg-trailer.4722c4a2.jpg";